import { RECORDING_PROVIDERS } from '../../providerIds'

export const RECORDING_SESSION_STATES = Object.freeze({
  unknown: 'unknown',
  recording: 'recording',
  stopped: 'stopped',
  failed: 'failed',
})

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

export function normalizeRecordingSessionState(
  state,
  fallbackValue = RECORDING_SESSION_STATES.unknown,
) {
  return Object.values(RECORDING_SESSION_STATES).includes(state) ? state : fallbackValue
}

export function createRecordingArtifactManifest(overrides = {}) {
  const safeOverrides = isPlainObject(overrides) ? overrides : {}

  return {
    storageProvider:
      typeof safeOverrides.storageProvider === 'string' ? safeOverrides.storageProvider : null,
    storageBucket:
      typeof safeOverrides.storageBucket === 'string' ? safeOverrides.storageBucket : null,
    pathPrefix: typeof safeOverrides.pathPrefix === 'string' ? safeOverrides.pathPrefix : null,
    recordingPath:
      typeof safeOverrides.recordingPath === 'string' ? safeOverrides.recordingPath : null,
    rawFileList: typeof safeOverrides.rawFileList === 'string' ? safeOverrides.rawFileList : null,
  }
}

export function createRecordingSessionMetadata(overrides = {}) {
  const safeOverrides = isPlainObject(overrides) ? overrides : {}

  return {
    provider:
      Object.values(RECORDING_PROVIDERS).includes(safeOverrides.provider)
        ? safeOverrides.provider
        : null,
    bookedEventId:
      typeof safeOverrides.bookedEventId === 'string' ? safeOverrides.bookedEventId : null,
    recordingSessionId:
      typeof safeOverrides.recordingSessionId === 'string'
        ? safeOverrides.recordingSessionId
        : null,
    providerRecordingId:
      typeof safeOverrides.providerRecordingId === 'string'
        ? safeOverrides.providerRecordingId
        : null,
    providerResourceId:
      typeof safeOverrides.providerResourceId === 'string'
        ? safeOverrides.providerResourceId
        : null,
    providerUid:
      typeof safeOverrides.providerUid === 'string' ? safeOverrides.providerUid : null,
    channelName: typeof safeOverrides.channelName === 'string' ? safeOverrides.channelName : null,
    status: normalizeRecordingSessionState(safeOverrides.status),
    startedAt: typeof safeOverrides.startedAt === 'string' ? safeOverrides.startedAt : null,
    stoppedAt: typeof safeOverrides.stoppedAt === 'string' ? safeOverrides.stoppedAt : null,
    artifactManifest: createRecordingArtifactManifest(safeOverrides.artifactManifest),
  }
}

export function getLegacyRecordingIdentifiers(recordingSession) {
  return {
    resourceId: recordingSession?.providerResourceId || null,
    sid: recordingSession?.providerRecordingId || null,
  }
}

export function isRecordingSessionActive(recordingSession) {
  return recordingSession?.status === RECORDING_SESSION_STATES.recording
}
